
import React from 'react';

const BalanceCardSkeleton = () => {
    return (
        <div className="balancecardv2 skeleton-balancecard">
            <div className="balancecardv2__container">

                {/* Header Skeleton */}
                <div className="balancecardv2__top">
                    <div className="skeleton-text skeleton-title"></div>
                    <div className="skeleton-icon-group">
                        <div className="skeleton-icon"></div>
                        <div className="skeleton-icon"></div>
                    </div>
                </div>

                {/* Balance Skeleton */}
                <div className="balancecardv2__numbers">
                    <div className="skeleton-text skeleton-balance"></div>
                    <div className="skeleton-text skeleton-subtitle"></div>
                </div>

                {/* Actions Skeleton */}
                <div className="balancecardv2__actions">
                    <div className="skeleton-button"></div>
                    <div className="skeleton-button"></div>
                </div>
            </div>
        </div>
    );
};

export default BalanceCardSkeleton;
